import { app_login_subject_to_tenant_link_audit_trail_RowClass } from "../../dbschema/app_login_subject_to_tenant_link_audit_trail.model";
import { BaseContainerModel } from "../base-container.model";

export class AppLoginSubjectToTenantLinkAuditTrailContainerModel extends BaseContainerModel {
  app_login_subject_to_tenant_link_audit_trail: app_login_subject_to_tenant_link_audit_trail_RowClass = new app_login_subject_to_tenant_link_audit_trail_RowClass();
}
